module.exports = __webpack_public_path__ + "static/media/features4.9347b84a.png";